import { render, staticRenderFns } from "./SalesFreightOrder.vue?vue&type=template&id=c8787f10&scoped=true"
import script from "./SalesFreightOrder.vue?vue&type=script&lang=js"
export * from "./SalesFreightOrder.vue?vue&type=script&lang=js"
import style0 from "./SalesFreightOrder.vue?vue&type=style&index=0&id=c8787f10&prod&scoped=true&lang=css"
import style1 from "./SalesFreightOrder.vue?vue&type=style&index=1&id=c8787f10&prod&lang=css"
import style2 from "./SalesFreightOrder.vue?vue&type=style&index=2&id=c8787f10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8787f10",
  null
  
)

export default component.exports